import { injectIntl, IntlShape } from 'react-intl';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { MeetingTemplatesPresentation } from './meeting-templates.presentation';
import { MeetingTemplatesVM } from './meeting-templates.viewmodel';
import { connectedBlueprintsVM } from '../blueprints.context';

export type ContainerProps = {
    accountId: number;
};

const MeetingTemplatesContainer = injectIntl(withViewModel(
    MeetingTemplatesPresentation,
    ({ accountId, intl }: ContainerProps & { intl: IntlShape}) => {
        const meetingTemplatesVM = new MeetingTemplatesVM(accountId, intl);

        meetingTemplatesVM.initialize();

        return meetingTemplatesVM;
    },
    props => [ props.accountId ]
));

export const MeetingTemplates = connectedBlueprintsVM<ContainerProps>(
    MeetingTemplatesContainer,
    vm => ({
        accountId: vm.getAccountId()
    })
);
